module.exports = __webpack_public_path__ + "static/media/svg-coche-bleue.4694795b.svg";